import { useEffect, useRef } from 'react';
import confetti from '../../utils/confettiInstancia';

// Estoura confete de verdade (canvas-confetti — a mesma biblioteca usada em
// telas de "você ganhou" mundo afora) a partir da posição do elemento pai
// na tela. Velocidade/alcance/vida bem mais baixos que o preset padrão da
// biblioteca (que cobre a tela inteira) — aqui o objetivo é ficar
// concentrado ao redor do número, não espalhar pela página toda.
function estourar(origemX, origemY) {
  const contagemBase = 90;
  const base = {
    origin: { x: origemX, y: origemY },
    zIndex: 9999,
    gravity: 1.4, // cai mais rápido, então também some mais perto de onde nasceu
    ticks: 130 // vida mais curta que o padrão (200) — desaparece antes de viajar longe
  };

  const disparar = (proporcao, opcoes) => {
    confetti({ ...base, ...opcoes, particleCount: Math.floor(contagemBase * proporcao) });
  };

  disparar(0.3, { spread: 30, startVelocity: 22 });
  disparar(0.3, { spread: 50, startVelocity: 18 });
  disparar(0.4, { spread: 80, startVelocity: 14, decay: 0.9, scalar: 0.85 });
}

// `triggerKey` muda a cada vez que o passo 3 fica ativo — dispara o confete
// a partir do centro do elemento âncora (o próprio componente não renderiza
// nada visível, só posiciona o disparo).
const Confetti = ({ triggerKey }) => {
  const ancoraRef = useRef(null);

  useEffect(() => {
    if (!triggerKey || !ancoraRef.current) return;
    const rect = ancoraRef.current.getBoundingClientRect();
    const x = (rect.left + rect.width / 2) / window.innerWidth;
    const y = (rect.top + rect.height / 2) / window.innerHeight;
    estourar(x, y);
  }, [triggerKey]);

  return <span ref={ancoraRef} className="absolute inset-0 pointer-events-none" />;
};

export default Confetti;
